import React, { useState, useEffect } from "react";
import Preloader from "../../../components/Preloader/Preloader";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import ButtonComponent from 'react-button-component';
import LoadingOverlay from 'react-loading-overlay';
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ColorPicker from "react-color-palette";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
const useStyles = makeStyles((theme) => ({
	btnSearch: {
        marginTop: 30,
        backgroundColor: "green",
	},
    modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
        overflowY:"auto",
        maxHeight:"100vh",
		margin: "0 auto",
	},
    modal2: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "400px",
		margin: "0 auto",
	},
    paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
    field:{
        width: "90%"
    },
    autoComplete:{
        width: "90%"
    },
    modalBtn:{
        display:"flex-end"
    },
    dangerBtn:{
        backgroundColor:"red",
        color:"white"
    },
    floatRight: {
        float:"right"
    }
}));
const PackageSalesNavSettings = (props) => {
    const classes = useStyles();
    const [nextPagePath, setNextPagePath] = useState("");
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
    const [isLoaded, setisLoaded] = useState();
    const [selectedpackagetype, setSelectedPackageType] = useState("");
    const [selectedRecord, setSelectedRecord] = useState({});
    const [record_data, setRecordData] = useState({});
    const [saveState, setSaveState] = useState(false);
    const [franchiseID, setFranchiseID] = useState(0);

    //Color picker
    const [color, setColor] = useState("#339933");
    //checkboxes state
    const [cb1, checkCB1] = useState(false);
    const [cb2, checkCB2] = useState(false);
    const [cb3, checkCB3] = useState(false);
    const [cb4, checkCB4] = useState(false);
    const [cb5, checkCB5] = useState(false);

	const nextpage =  {
		pathname: "/packagesalesnav-settings-franchise",
	}
    const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
    };
	//ApiData Component useState SOF
    const packagesalesnavsummary = () => {
        setisLoaded(false);
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
            prep_data: prep_data
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'packagesalesnavsummary';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            loadNavDetails(res.data);
		});
	};
    const updaterecord = () => {
        //get data for warehouse/location dropdown
		const form_data = {
			id: selectedRecord.id,
            record_data: record_data,
            color: color
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'updatepackagesalesnav';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("success");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
                packagesalesnavsummary();
            }else{
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
            }
		});
	};
    const saverecord = () => {
        //get data for warehouse/location dropdown
		const form_data = {
            record_data: record_data,
            color:color
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'savepackagesalesnav';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("success");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                    packagesalesnavsummary();
                }, 3000)
            }else{
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
            }
		});
	};

    const deleterecord = () => {
        handleClose2();
        //get data for warehouse/location dropdown
		const form_data = {
            id: selectedRecord.id
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'deletepackagesalesnav';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("success");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
                packagesalesnavsummary();
            }else{
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
            }
		});
	};

    const validate_required = () => {
		const apiUrl = process.env.REACT_APP_API_URL+'validate_required';
		const form_data = {
			required_fields: required_fields,
			reqfield_obj: record_data
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			if(res.data.result.success == 1){
				if(saveState == true){
                    saverecord();
                }else{
                    updaterecord();
                }
                handleClose();
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF

	//Table Settings
	const [TABLE_DATA, loadDataTable] = useState([]);
	const loadNavDetails = (data) => {
        refreshTable();
		const newData = [...TABLE_DATA];
		for (let i=0;i < data.navdetailssummary.length;i++) {
            if(data.rawnavdetailssummary[i].isfranchise==1)
			{
                const tempObj = {id:data.navdetailssummary[i][0], navname:data.navdetailssummary[i][1],
                    action:<Grid container spacing={0}>
                                <Grid xs={12} sm={3}>
                                    <Button variant="contained" color="primary" className={classes.floatRight} onClick={(e) => {viewfranchisedetails(data.navdetailssummary[i][0],data.navdetailssummary[i][1])}}>Franchise Details</Button>
                                </Grid>
                                <Grid xs={12} sm={3}>
                                    <Button variant="contained" color="primary" className={classes.floatRight}  onClick={(e) => {viewdetails(data.rawnavdetailssummary[i])}}>Edit</Button>
                                </Grid>
                                <Grid xs={12} sm={3}>
                                    <Button variant="contained" className={[classes.dangerBtn, classes.floatRight]}  onClick={(e) => {process_delete(data.rawnavdetailssummary[i])}}>Delete</Button>
                                </Grid>
                            </Grid>
                    }
                newData.push(tempObj);
            }
            else
            {   
                const tempObj = {id:data.navdetailssummary[i][0], navname:data.navdetailssummary[i][1], 
                    action:<Grid container spacing={0}>
                                <Grid xs={12} sm={3}>
                                    <Button variant="contained" color="primary" onClick={(e) => {viewdetails(data.rawnavdetailssummary[i])}}>Edit</Button>
                                </Grid>
                                <Grid xs={12} sm={3}>
                                    <Button variant="contained" className={classes.dangerBtn} onClick={(e) => {process_delete(data.rawnavdetailssummary[i])}}>Delete</Button>
                                </Grid>
                            </Grid>
                    }
                newData.push(tempObj);
            }
        }
		loadDataTable([...newData]);
        setisLoaded(true);
	};
    
	const refreshTable = () => {
        TABLE_DATA.length = 0;
        const newData = [...TABLE_DATA];
		loadDataTable([...newData]);
	}

    const viewfranchisedetails = (franchiseid,franchisenavname) => {
        let tempData = {
            navid:franchiseid,
            navname:franchisenavname
        }
        nextpage['franchisedetails'] = tempData;
        proceed_to_nextpage();
	}

    const proceed_to_nextpage = () =>{
        props.history.push(nextpage);
    }

	const TABLE_COLUMNS = [
		{
		  name: 'id',
		  label: 'ID',
		}, {
		  name: 'navname',
		  label: 'Navigation Name',
		},  {
            name: 'action',
            label: 'Action',
            options: {
                setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "200px" }}),
                customBodyRender: (data, type, row) => {return <pre>{data}</pre>}
          },
        }
	];
	
	const TABLE_OPTION = {
        selectableRows: 'none'
	};
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
    const handleOpen2 = () => {
		setOpen2(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
    const handleClose2 = () => {
		setOpen2(false);
	};
	//Modal Settings EOF
    const formatDate = (date) => {
		let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;

		return [year, month, day].join('-');
	}

    const viewdetails = (navdetails) => {
        setSelectedRecord(navdetails);
        handleOpen();
        setSaveState(false);
    }

    const new_record = () => {
        setSaveState(true);
        const tempData = {};
		setRecordData(tempData);
        setColor("#339933");
        handleOpen();
        checkCB1(false);
        checkCB2(false);
        checkCB3(false);
        checkCB4(false);
        checkCB5(false);
        const newData = {};
        newData['itemselection']= "no";
        newData['discounteditems']= "no";
        newData['isfranchise']= 0;
        newData['isidnoincentive']= 0;
        newData['isidnoincentivemc']= 0;
        newData['free_accounts']= 0;
        newData['plusvalue']= 0;
        newData['customdramount']= 0;
        setRecordData({ ...newData });
    }
    useEffect(() => {
        onRecordOpen();
    }, [selectedRecord]);
    const dropdownPackageType  = ['Silver','Platinum'];
    //FormData
	const [prep_data, setData] = useState({"startDate":formatDate(new Date()),"endDate":formatDate(new Date())});
	//FormData EOF
	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
        isLoggedIn();
        packagesalesnavsummary();
    }, []);
    //OnLoad Event/Data Fetching SOF

	const onInputChange = (event) => {
		const newData = {...prep_data};
		newData[event.target.name]= event.target.value;
		setData({ ...newData });
	}

    const onRecordChange = (event) => {
		const newData = {...record_data};
		newData[event.target.name]= event.target.value;
		setRecordData({ ...newData });
	}
    const onRecordChangeCB = (event) => {
        if (event.target.checked == true) {
            check_checkbox(event.target.name);
        } else {
            uncheck_checkbox(event.target.name);
        }
    }
    const check_checkbox = (checkboxname) => {
        const newData = {...record_data};
        if(checkboxname == "itemselection"){
            checkCB1(true);
            newData['itemselection']= "yes";
        }
        if(checkboxname == "discounteditems"){
            checkCB2(true);
            newData['discounteditems']= "yes";
        }
        if(checkboxname == "isfranchise"){
            checkCB3(true);
            newData['isfranchise']= 1;
        }
        if(checkboxname == "isidnoincentive"){
            checkCB4(true);
            newData['isidnoincentive']= 1;
        }
        if(checkboxname == "isidnoincentivemc"){
            checkCB5(true);
            newData['isidnoincentivemc']= 1;
        }
        setRecordData({ ...newData });
    }
    const uncheck_checkbox = (checkboxname) => {
        const newData = {...record_data};
        if(checkboxname == "itemselection"){
            checkCB1(false);
            newData['itemselection']= "no";
        }
        if(checkboxname == "discounteditems"){
            checkCB2(false);
            newData['discounteditems']= "no";
        }
        if(checkboxname == "isfranchise"){
            checkCB3(false);
            newData['isfranchise']= 0;
        }
        if(checkboxname == "isidnoincentive"){
            checkCB4(false);
            newData['isidnoincentive']= 0;
        }
        if(checkboxname == "isidnoincentivemc"){
            checkCB5(false);
            newData['isidnoincentivemc']= 0;
        }
        setRecordData({ ...newData });
    }
    
    const onRecordOpen = () => {
		const newData = {...record_data};
		newData['nav_name']= selectedRecord.nav_name;
        newData['nav_description']= selectedRecord.nav_description;
        newData['nav_code']= selectedRecord.nav_code;
        newData['package_type']= selectedRecord.package_type;
        newData['paid_accounts']= selectedRecord.paid_accounts;
        newData['free_accounts']= selectedRecord.free_accounts;
        newData['noofpackages']= selectedRecord.noofpackages;
        newData['customdramount']= selectedRecord.customdramount;
        newData['plusvalue']= selectedRecord.plusvalue;
        newData['save_function']= selectedRecord.save_function;
        //checkboxes
        if(selectedRecord.itemselection == "yes"){
            checkCB1(true);
        }else{
            checkCB1(false);            
        }
        if(selectedRecord.discounteditems == "yes"){
            checkCB2(true);
        }else{
            checkCB2(false);
        }
        if(selectedRecord.isfranchise == 1){
            checkCB3(true);
        }else{
            checkCB3(false);
        }
        if(selectedRecord.isidnoincentive == 1){
            checkCB4(true);
        }else{
            checkCB4(false);
        }
        if(selectedRecord.isidnoincentivemc == 1){
            checkCB5(true);
        }else{
            checkCB5(false);
        }
        newData['itemselection']= selectedRecord.itemselection;
        newData['discounteditems']= selectedRecord.discounteditems;
        newData['isfranchise']= selectedRecord.isfranchise;
        newData['isidnoincentive']= selectedRecord.isidnoincentive;
        newData['isidnoincentivemc']= selectedRecord.isidnoincentivemc;
		setRecordData({ ...newData });
        setColor(selectedRecord.nav_color);
	}

    const process_delete = (navdetails) => {
        handleOpen2();
        setSelectedRecord(navdetails);
    }

    const required_fields = [
		"discounteditems",
		"itemselection",
		"nav_code",
		"nav_description",
		"nav_name",
		"noofpackages",
		"package_type",
		"paid_accounts",
		"save_function"
	];
    //Date Picker EOF
	return (
		<div className="page">
            <LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/settings">
						<h4 className="header-title">Settings</h4>
					</NavLink>
					<Typography color="textPrimary">Package Sales Navigation Settings</Typography>
				</Breadcrumbs>
			</div>
            <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			<div className="page-container">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                name="navnamesearch"
                                label="Navigation Name"
                                variant="outlined"
                                type="text"
                                margin="normal"
                                className={classes.field}
                                onChange={onInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button 
								variant="contained" 
								color="primary"
                                className={classes.btnSearch}
								onClick={(e) => {
									packagesalesnavsummary();
								}}>
								Search
							</Button>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button 
								variant="contained" 
								color="primary"
                                className={classes.btnSearch}
								onClick={(e) => {
									new_record();
								}}>
								Add
							</Button>
                        </Grid>
                    </Grid>
                <Grid item xs={12}>
                { 
                    !isLoaded ?  <Preloader /> :										
                    <MUIDataTable
                        title={
                            <div>
                                <div className="table-title">
                                    Package Sales Navigation Table
                                </div>
                            </div>
                        }
                        id="table-grid"
                        data={TABLE_DATA}
                        columns={TABLE_COLUMNS}
                        options={TABLE_OPTION}
                    />
                }
                </Grid>
			</div>
            </LoadingOverlay>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <h4 id="transition-modal-title">Navigation Details</h4>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <ColorPicker
                                            width={300}
                                            height={100}
                                            defaultColor={color}
                                            onChange={color => setColor(color.hex)}
                                        />
                                    </Grid>
                                    <Grid container xs={12} sm={6} justify="space-between" alignItems="center" alignContent="center">
                                        <Grid items xs={12}>
                                            <h1 style={{color:color}}>AaBbYyZz</h1>
                                        </Grid>
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="nav_name"
                                            label="Navigation Name"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.nav_name}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="nav_description"
                                            label="Decscription"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.nav_description}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="nav_code"
                                            label="Navigation Code"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.nav_code}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <Autocomplete
                                            options={dropdownPackageType}
                                            autoComplete
                                            includeInputInList
                                            value={record_data.package_type}
                                            className={classes.autoComplete}
                                            name="package_type"
                                            required="true"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="normal"
                                                    label="Package Type"	
                                                    variant="outlined"
                                                    required="true"
                                                />
                                            )}
                                            onChange={(event, newValue) => {
                                                if (!newValue == "" || !newValue == null){
                                                    const newData = {...record_data};
                                                    newData['package_type']= newValue;
                                                    setRecordData({ ...newData });
                                                }
                                            }}
                                        />
                                    </Grid>  
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="paid_accounts"
                                            label="Paid Accounts"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.paid_accounts}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="free_accounts"
                                            label="Free Accounts"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            value={record_data.free_accounts}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>  
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="noofpackages"
                                            label="No. of Packages"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.noofpackages}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="customdramount"
                                            label="Custom DR Amount"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            value={record_data.customdramount}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="plusvalue"
                                            label="Plus Value"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            value={record_data.plusvalue}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="save_function"
                                            label="Save Function"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.save_function}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                </Grid>   
                                <Grid container spacing={3} style={{marginTop:"20px"}}>
                                    <Grid xs={12} sm={4}>
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                                checked={cb1}
                                                onChange={onRecordChangeCB}
                                                name="itemselection"
                                                color="primary"
                                            />
                                            }
                                            label="Item Selection"
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={4}>
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                                checked={cb2}
                                                onChange={onRecordChangeCB}
                                                name="discounteditems"
                                                color="primary"
                                            />
                                            }
                                            label="Discounted Item"
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={2}>
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                                checked={cb3}
                                                onChange={onRecordChangeCB}
                                                name="isfranchise"
                                                color="primary"
                                            />
                                            }
                                            label="Franchise"
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                                checked={cb4}
                                                onChange={onRecordChangeCB}
                                                name="isidnoincentive"
                                                color="primary"
                                            />
                                            }
                                            label="Insert in IDNO Incentive?"
                                        />
                                    </Grid> 
                                    <Grid xs={12} sm={6} style={{marginBottom:"20px"}}>
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                                checked={cb5}
                                                onChange={onRecordChangeCB}
                                                name="isidnoincentivemc"
                                                color="primary"
                                            />
                                            }
                                            label="Insert in IDNO Incentive MC?"
                                        />
                                    </Grid>
                                </Grid>
                                <div className={classes.button} style={{float:"right"}}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Button 
                                            variant="contained" 
                                            color="primary"
                                            onClick={validate_required}
                                        >
                                            Save
                                        </Button>
                                    </Grid>
                                </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal2}
                    open={open2}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open2}>
                        <div className={classes.paper}>
                            <h4 id="transition-modal-title">System Message</h4>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <h4>Are you sure you want to delete this navigation</h4>
                                    </Grid>
                                </Grid>
                                <div className={classes.button}>
                                <Grid container spacing={1}>
                                    <div  className={classes.floatRight}></div>
                                    <Grid item xs={3}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose2}
                                            className={classes.buttonMarginRight}
                                            style={{backgroundColor:"red",color:"white",float:'right'}}
                                        >
                                            No
                                        </Button>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Button
                                            variant="contained"
                                            onClick={deleterecord}
                                        >
                                            Yes
                                        </Button>
                                    </Grid>
                                </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
		</div>
	);
};

export default PackageSalesNavSettings;
